import { useQuery, UseQueryResult, useMutation } from '@tanstack/react-query';
import { type Alert, type EditAlert } from '../../shared/types';
import { deleteAlert, getAlerts, postAlert, putAlert, postAlertSnooze } from '../utilities/api';
import { queryClient } from '.';

export const queryKeys = {
    getAlerts: () => ['alerts', 'get'],
};

export const useAlerts = (): UseQueryResult<Alert[], Error> => {
    return useQuery({ queryKey: queryKeys.getAlerts(), queryFn: getAlerts, retry: false, refetchInterval: 60000 });
};

export const useUpdateAlert = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditAlert }) => putAlert(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAlerts() });
        },
    });
};

export const useCreateAlert = () => {
    return useMutation({
        mutationFn: (data: EditAlert) => postAlert(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAlerts() });
        },
    });
};

export const useDeleteAlert = () => {
    return useMutation({
        mutationFn: (id: string) => deleteAlert(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAlerts() });
        },
    });
};

export const useUpdateAlertSnooze = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditAlert }) => postAlertSnooze(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAlerts() });
        },
    });
};
